<template>
  <div v-show="isEnabled" class="control-panel--ignore-close fixed left-4 top-4 z-[999]">
    <!-- todo   v-closable="{ executable: () => (controlPanelIsOpen = false), exclude: '.control-panel&#45;&#45;ignore-close' }"-->
    <img
      src="/images/fabrique.png"
      class="z-[999] h-[50px] w-[50px] cursor-pointer hover:shadow-lg hover:brightness-105"
      alt="Fabrique logo"
      :title="t_('enable')"
      @click="toggleOpen()"
    />
    <div v-show="isOpen" class="absolute z-50 w-96 border-2 border-solid border-gray-300 bg-white drop-shadow">
      <!-- urls -->
      <OrganismControlPanelFoldout v-if="urls.length > 0" :has-foldout="urls.length > 1">
        <template #icon>
          <AtomIconPencil class="mr-3 h-4 w-4 shrink-0" />
        </template>
        <template #label>
          <AtomLink :url="urls.length === 1 ? urls[0]?.url : undefined">
            {{ urls.length === 1 ? urls[0]?.label : t_('edit-pages') }}
          </AtomLink>
        </template>
        <template #foldout>
          <ul class="w-96">
            <li v-for="{ label, url } in urls" :key="url">
              <AtomLink :url="url" class="flex items-center px-4 py-1 hover:bg-gray-200">
                <AtomIconPencil class="mr-3 h-4 w-4 shrink-0" />
                <span class="flex-grow" v-html="label" />
              </AtomLink>
            </li>
          </ul>
        </template>
      </OrganismControlPanelFoldout>

      <!-- translations -->
      <OrganismControlPanelFoldout :has-foldout="translations.length > 0">
        <template #icon>
          <AtomIconTranslate class="mr-3 h-4 w-4 shrink-0" />
        </template>
        <template #label>
          {{ tc_('translations-found', translations.length) }}
        </template>
        <template #foldout>
          <ul>
            <li v-for="[key, translation] in translations" :key="key">
              <AtomLink :url="translationUrls[key]" class="flex items-center px-4 py-1 hover:bg-gray-200">
                <AtomIconPencil class="mr-3 w-4 h-4 shrink-0" :class="{ 'text-gray-200': !translationUrls[key] }" />
                <span class="font-mono text-xs text-gray-600">{{ key }}</span>
                <span class="ml-4">{{ translation }}</span>
              </AtomLink>
            </li>
          </ul>
        </template>
      </OrganismControlPanelFoldout>

      <!-- toggle control-panel -->
      <OrganismControlPanelFoldout :has-foldout="false" :title="t_('reset')" @click="reset()">
        <template #icon>
          <AtomIconPowerSwitch class="mr-3 h-4 w-4 shrink-0" />
        </template>
        <template #label>
          {{ t_('disable') }}
        </template>
      </OrganismControlPanelFoldout>
    </div>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const controlPanelStore = useControlPanelStore()
const pageStore = usePageStore()

const { t_, tc_ } = setupTranslationPrefixer('ControlPanel')

const isOpen = ref(false)

const isEnabled = computed(() => controlPanelStore.isEnabled)
const page = computed(() => pageStore.page)
const translations = computed(() => controlPanelStore.translations)
const translationUrls = computed(() => controlPanelStore.translationUrls)

const urls = computed(() =>
  Object.entries(page.value?.controlPanel || {})
    .filter((entry): entry is [string, string] => typeof entry[1] === 'string' && /^https?:\/\//i.test(entry[1]))
    .map(([label, url]) => ({ label, url })),
)

if (/yes|true|1/.test(String(route.query.cp ?? ''))) {
  controlPanelStore.enable()
}

controlPanelStore.fetchTranslationUrls()

// Pull the translations the `postTranslation` hook collected during render into the store, after render
// (on mount and on each navigation) so the reactive update cannot loop with this panel.
onMounted(() => controlPanelStore.syncTranslations())
watch(
  () => route.fullPath,
  () => nextTick(() => controlPanelStore.syncTranslations()),
)

function reset() {
  controlPanelStore.reset()
}

function toggleOpen() {
  isOpen.value = !isOpen.value
}
</script>
